import { render, staticRenderFns } from "./dettaglioAgente.html?vue&type=template&id=e966c498&"
import script from "./DettaglioAgente.vue?vue&type=script&lang=js&"
export * from "./DettaglioAgente.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports